import { render, staticRenderFns } from "./projectsBudget.vue?vue&type=template&id=557520cf&scoped=true&"
import script from "./projectsBudget.vue?vue&type=script&lang=js&"
export * from "./projectsBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557520cf",
  null
  
)

export default component.exports